import { phone } from 'filters'
import layout from 'layouts/default'
import pagination from 'components/pagination'
import { confirm } from 'components/modals'
import { hasPermits } from 'directives'
import { twoFactorPolicy } from 'services'


const directives = {
  hasPermits
}

const filters = {
  phone
}

const components = {
  layout,
  pagination,
  confirm
}

const methods = {
  twoFactorActionLabel (value) {
    return twoFactorPolicy.label(value)
  },
  twoFactorEnabled (item) {
    return twoFactorPolicy.enabled(item)
  },
  loadPage (page) {
    this.loading = true;
    this.$store.dispatch('users.getAll', {
      page,
      _q: this.searchKey,
      type: this.type !== 'all' ? this.type : null,
      two_fa_status: this.twoFaStatus !== 'all' ? this.twoFaStatus : null
    }).then (() => {
      this.loading = false;
    });
  },
  search (searchKey) {
    this.searchKey = searchKey;
    this.loadPage(1);
  },
  reset2fa (item) {
    this.$refs.reset2faConfirm.confirm('Are you sure you want to reset 2FA for this user?', () => {
      this.twoFaResetLoadings[item.id] = true
      this.twoFaResetLoadings = _.clone(this.twoFaResetLoadings)

      this.$store.dispatch('users.disable2fa', item.id).then(() => {
        this.twoFaResetLoadings[item.id] = false
        this.twoFaResetLoadings = _.clone(this.twoFaResetLoadings)

        if (this.$store.state.users.errors) {
          this.errors = _.cloneDeep(this.$store.state.users.errors.errors);
          if (this.errors && this.errors.hasOwnProperty('message')) {
            toastr.error(this.errors.message);
          } else {
            toastr.error(this.$store.state.users.errors.message || 'Unable to reset 2FA');
          }
        } else {
          toastr.success('2FA has been reset');
        }
      })
    });
  },
  removeUser (item) {
    this.$refs.deleteConfirm.confirm('Are you sure?', () => {
      this.users_loadings[item.id] = true

      this.$store.dispatch('users.removeUser', item.id).then(() => {
        this.users_loadings[item.id] = false

        if (this.$store.state.users.errors) {
          this.errors = _.cloneDeep(this.$store.state.users.errors.errors);
          if (this.errors.hasOwnProperty('message')) {
            toastr.error(this.errors.message);
          }
        }
      })
    });
  }
}

const computed = {
  users () {
    let users = _.cloneDeep(this.$store.state.users.all);
    _.each(users.data, (user) => {
      this.users_loadings[user.id] = false;
    });
    this.users_loadings = _.clone(this.users_loadings);
    return users;
  }
}

export default {
  name: 'all-users',
  components,
  methods,
  computed,
  filters,
  directives,
  data () {
    return {
      loading: true,
      searchKey: null,
      users_loadings: {},
      type: 'all',
      twoFaStatus: 'all',
      twoFaResetLoadings: {}
    }
  },
  created () {
    this.loadPage (this.$route.query.page || 1);
  }
}
